import getScenarioStore from './getScenarioStore';
import { SearchScenarioId } from '../store/schema/SearchScenarioId';

export default function isQFRequestIdEqualToLatest(
    qfRequestId: string,
    scenarioId: SearchScenarioId
): boolean {
    return qfRequestId === getScenarioStore(scenarioId).latestQFRequestId;
}
